package com.example.mystybag.sharedmodels.project.requestModels.reservations

import com.example.mystybag.sharedmodels.AllCommands.MYPOS_GET_TRANSACTION_STATUS
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
class GetMyPosTransactionStatusRequestModel(
    val transactionReference: String = ""
) : BaseRequestModel(api = MYPOS_GET_TRANSACTION_STATUS)
